import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-672078df"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "cards render-hide-scroll"
};
const _hoisted_2 = {
  class: "nav_select"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 1,
  class: "list"
};
const _hoisted_6 = {
  class: "order_list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "header"
};
const _hoisted_9 = {
  class: "order_no"
};
const _hoisted_10 = {
  class: "activity_list"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "info"
};
const _hoisted_13 = {
  class: "render-font-family"
};
const _hoisted_14 = {
  class: "footer"
};
const _hoisted_15 = {
  class: "num"
};
const _hoisted_16 = /*#__PURE__*/_createTextVNode("合计：");
const _hoisted_17 = {
  class: "btns"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  class: "deliverDialog"
};
const _hoisted_20 = {
  class: "top"
};
const _hoisted_21 = {
  key: 0,
  class: "pay_type"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "weixin"
}, "微信支付", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "alipay"
}, "支付宝", -1));
const _hoisted_24 = {
  class: "btns"
};
const _hoisted_25 = ["innerHTML"];
const _hoisted_26 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_list = _resolveComponent("list");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(['nav_status', {
      'appNav': $data.env.isModianIos() || $data.env.isModianAndroid()
    }, {
      'wxApp': $data.env.isWxApp()
    }])
  }, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nav, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      class: _normalizeClass({
        'active': $data.card_status == item.status
      }),
      key: index,
      onClick: _withModifiers($event => $options.goContainer(item), ["stop"])
    }, _toDisplayString(item.txt), 11, _hoisted_3);
  }), 128))]), _createElementVNode("div", {
    class: "nav_order_status",
    onScroll: _cache[0] || (_cache[0] = (...args) => $options.rowScroll && $options.rowScroll(...args))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.status_nav, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      class: _normalizeClass({
        'active': $data.status == item.status
      }),
      key: index,
      onClick: _withModifiers($event => $options.changeNav(item.status), ["stop"])
    }, _toDisplayString(item.txt), 11, _hoisted_4);
  }), 128))], 32)], 2), $data.total == 0 ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[1] || (_cache[1] = $event => $data.loading = $event),
    "immediate-check": "false",
    onLoad: $options.onLoad
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.order_list, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "item",
        key: index,
        onClick: _withModifiers($event => $options.goOrderDetail(item.postage_order_no), ["stop"])
      }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, "发货单号：" + _toDisplayString(item.postage_order_no), 1), _createElementVNode("p", {
        class: _normalizeClass(['status', {
          'pay': item.status == 0
        }])
      }, _toDisplayString($options.getStatusTxt(item.status)), 3)]), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.activity_infos, (orderItem, orderIndex) => {
        return _openBlock(), _createElementBlock("div", {
          class: "activity_item",
          key: orderIndex
        }, [_createElementVNode("img", {
          src: `${_ctx.$imgUrlFilter(orderItem.activity_img_url, 128)}`
        }, null, 8, _hoisted_11), _createElementVNode("div", _hoisted_12, [_createElementVNode("p", _hoisted_13, _toDisplayString(orderItem.activity_name), 1), _createElementVNode("span", null, "卡牌数：" + _toDisplayString(orderItem.card_num) + "张", 1)])]);
      }), 128))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", null, _toDisplayString(item.card_num) + "张", 1)]), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.buttons, (btn, btnIndex) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['btn', {
            'pay': btn.type == 'to_pay'
          }]),
          key: btnIndex,
          onClick: _withModifiers($event => $options.opOrder(btn.type, item), ["stop"])
        }, _toDisplayString(btn.title), 11, _hoisted_18);
      }), 128))])])], 8, _hoisted_7);
    }), 128))])]),
    _: 1
  }, 8, ["loading", "onLoad"])])), _createVNode(_component_van_action_sheet, {
    show: $data.deliverVisible,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $data.deliverVisible = $event),
    title: "支付确认",
    "close-icon": $data.closeIcon
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [!$data.env.isWeixin() && !$data.env.isWeibo() ? (_openBlock(), _createElementBlock("div", _hoisted_21, [!$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: _cache[2] || (_cache[2] = $event => $options.clickfn('weixin_mina')),
      class: "item"
    }, [_hoisted_22, _createElementVNode("i", {
      class: _normalizeClass(['iconfont', {
        active: $data.pay_resource == 'weixin_mina'
      }, $data.pay_resource == 'weixin_mina' ? 'icon-singleselect' : 'icon-singleunselected'])
    }, null, 2)])) : _createCommentVNode("", true), !$data.env.isWeixin() ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      onClick: _cache[3] || (_cache[3] = $event => $options.clickfn('alipay')),
      class: "item"
    }, [_hoisted_23, _createElementVNode("i", {
      class: _normalizeClass(['iconfont', {
        active: $data.pay_resource == 'alipay'
      }, $data.pay_resource == 'alipay' ? 'icon-singleselect' : 'icon-singleunselected'])
    }, null, 2)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
      class: "cancel",
      onClick: _cache[4] || (_cache[4] = _withModifiers($event => $data.deliverVisible = false, ["stop"]))
    }, "取消"), _createElementVNode("div", {
      onClick: _cache[5] || (_cache[5] = _withModifiers((...args) => $options.confirmPay && $options.confirmPay(...args), ["stop"]))
    }, "确认支付")])])]),
    _: 1
  }, 8, ["show", "close-icon"]), _createElementVNode("div", {
    class: "html",
    ref: "html",
    innerHTML: $data.html
  }, null, 8, _hoisted_25), _createElementVNode("iframe", {
    style: {
      "width": "0",
      "height": "0",
      "position": "absolute",
      "opacity": "0",
      "z-index": "-1"
    },
    id: "webActivityShow",
    class: "dragArea list-group iphone-dragArea",
    src: $data.iframeUrl
  }, null, 8, _hoisted_26)]));
}